export const privateKey = process.env.REACT_APP_WALLET_PRIVATE_KEY;
export const rpcUrl = process.env.REACT_APP_RPC_URL;

export const invalidBlock = {
  block_hash: '0x0000000000000000000000000000000000000000',
  block_number: 87,
  block_reward: '0x0000000000000000000000000000000000000000',
  data: '0x0000000000000000000000000000000000000000',
  logs_bloom: '0x0000000000000000000000000000000000000000',
  merkle_root: '0x0000000000000000000000000000000000000000',
  previous_hash: '0x0000000000000000000000000000000000000000',
  reciept_root: '0x0000000000000000000000000000000000000000',
  state_root: '0x0000000000000000000000000000000000000000',
  timestamp: 1720633163,
  to: '0x0000000000000000000000000000000000000000',
  transaction_root: '0x0000000000000000000000000000000000000000',
  transactions: null,
  value: '0x0000000000000000000000000000000000000000',
  version: 1,
};

export function sleep(ms = 2000) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
